/** Interruptor do design (trilho 40×24). */
export function Interruptor({
  ligado,
  aoMudar,
  rotulo,
  desabilitado = false,
}: {
  ligado: boolean;
  aoMudar: (ligado: boolean) => void;
  /** ID do texto que dá nome ao interruptor. */
  rotulo: string;
  desabilitado?: boolean;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={ligado}
      aria-labelledby={rotulo}
      disabled={desabilitado}
      onClick={() => aoMudar(!ligado)}
      className={`relative h-6 w-10 shrink-0 rounded-xl transition-colors disabled:opacity-50 ${
        ligado ? 'bg-destaque' : 'bg-trilho'
      }`}
    >
      <span
        className={`absolute top-1 size-4 rounded-full transition-[left] ${
          ligado ? 'left-5 bg-destaque-texto' : 'left-1 bg-texto-2'
        }`}
      />
    </button>
  );
}
